import { CapoPlugin } from "/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];